import last from 'lodash/last';

const _last = last
export default _last;
